import { render, staticRenderFns } from "./shipping-details.vue?vue&type=template&id=474afcd5&scoped=true&"
import script from "./shipping-details.vue?vue&type=script&lang=js&"
export * from "./shipping-details.vue?vue&type=script&lang=js&"
import style0 from "./shipping-details.vue?vue&type=style&index=0&id=474afcd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474afcd5",
  null
  
)

export default component.exports